import { useContext } from 'react';
import GlobalContext from '~/context/giveaway/GlobalContext';
import ModalContext from '~/context/giveaway/ModalContext';
import DoubleCarat from '~/icons/DoubleCarat';
import { LightCtaButton } from '../CtaButton';

export default function HeroLayout() {
  const { setGiveawayModalOpen } = useContext(ModalContext);
  const { giveawayIsLive } = useContext(GlobalContext);
  const assetsPath = `${process.env.CVNA_APP_CDN_URL}/merch-assets/rbp/hero`;

  return (
    <div>
      <picture className="flex">
        <source
          srcSet={`${assetsPath}/bg-desktop.png?width=1800&trim=270,0,0,0`}
          media="(min-width: 1024px)"
        />
        <source
          srcSet={`${assetsPath}/bg-tablet.png?width=1024`}
          media="(min-width: 0px)"
        />
        <source
          srcSet={`${assetsPath}/bg-mobile.png?width=768`}
          media="(min-width: 0px)"
        />
        <img
          src={`${assetsPath}/bg-desktop.png?width=1800&trim=270,0,0,0`}
          alt="Styled & Dialed Giveaway"
          className="w-full object-none s:min-h-[428px] l:h-[680px] l:min-h-[442px]"
        />
      </picture>
      <picture>
        <source
          srcSet={`${assetsPath}/mountainscape-desktop.svg`}
          media="(min-width: 1024px)"
        />
        <source
          srcSet={`${assetsPath}/mountainscape-tablet.svg`}
          media="(min-width: 768px)"
        />
        <img
          className="absolute bottom-0 object-cover s:h-[67px] m:h-[89px] l:h-[134px] xl:h-[155px] xl:w-full"
          src={`${assetsPath}/mountainscape-mobile.svg`}
        />
      </picture>
      <picture>
        <source
          srcSet={`${assetsPath}/topography-desktop.svg`}
          media="(min-width: 1024px)"
        />
        <source
          srcSet={`${assetsPath}/topography-tablet.svg`}
          media="(min-width: 768px)"
        />
        <img
          className="absolute bottom-0 object-cover s:h-[181px] m:h-[170px] l:h-[238px] xl:w-full"
          src={`${assetsPath}/topography-desktop.svg`}
        />
      </picture>
      <div className="absolute top-0 m-auto mt-44 w-full text-center uppercase text-white l:mt-[84px]">
        <div className="h-96 l:h-[180px]">
          <p className="pb-4 text-xs font-bold l:pb-8 l:tl-header-m">
            Win Jaxson Riddle’s custom MTB at Carvana’s
          </p>
          <h1 className="text-[40px] font-black leading-none tracking-tight m:mb-4 m:text-[54px] l:text-7xl">
            STYLED & DIALED <br />
            GIVEAWAY
          </h1>
        </div>
        <div className="m-auto s:h-[113px] s:w-[140px] m:h-[153px] m:w-[190px] l:h-[221px] l:w-[275px]">
          <img
            className="-translate-x-12 -translate-y-20 object-cover m:-translate-x-[20px] m:-translate-y-[28px] l:-translate-x-[32px] l:-translate-y-[52px]"
            src={`${assetsPath}/jaxson-desktop.png?crop=564,454,x1100&optimize=high`}
            alt="Jaxson Riddle"
          />
        </div>
      </div>
      <div className="absolute bottom-24 flex w-full flex-col items-center gap-28 text-center text-white m:gap-16 l:gap-40">
        {giveawayIsLive ? (
          <LightCtaButton
            className="h-56 w-[200] m:h-48 m:w-[196px] l:h-56 l:w-[250px]"
            type="button"
            onClick={() => {
              setGiveawayModalOpen(true);
            }}
            data-analytics-id="Styled & Dialed Giveaway - Enter Now"
          >
            ENTER TO WIN
          </LightCtaButton>
        ) : (
          <p className="max-w-[448px] px-24 text-center text-white tl-body-s l:tl-body-l">
            The giveaway has ended, but you can still check out Jaxson Riddle’s
            custom MTB. Scroll to see 360° views, bike details, and Jaxson’s
            Carvana experience.
          </p>
        )}
        <div>
          <p className="mb-4 s:font-bold l:mb-8 l:text-2xl">Scroll</p>
          <DoubleCarat />
        </div>
      </div>
    </div>
  );
}
